( function( app ) {
  const COMPONENT = {
    className: 'team-member-callout',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const referrerIsInternal = this.referrerIsInternal();
      $( '.js-back-button' ).on( 'click', function( e ) {
        if ( !referrerIsInternal ) return true;
        e.preventDefault();
        window.history.back();
      } );
    },
    getBaseUrl() {
      return new URL( `${window.location.protocol}//${window.location.host}` );
    },
    referrerIsInternal() {
      const base = this.getBaseUrl();
      if ( document.referrer.includes( 'wp-admin' ) ) {
        return false;
      }

      return new URL( document.referrer, base ).hostname === base.hostname;
    },
    urlNotAdmin() {

    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'team-member-callout', COMPONENT );
} )( app );
